import { render } from "./PushNotificationModal.vue?vue&type=template&id=647c930a"
import script from "./PushNotificationModal.vue?vue&type=script&lang=js"
export * from "./PushNotificationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__